import {EntityContainerHashParamsModel} from "../../../core/components/router/models/entity-container-hash-params-model";

export class CompetitionContainerHashParamsModel extends EntityContainerHashParamsModel {
  seasonNum: Number;
}
